import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  background: linear-gradient(var(--bg-pro-gradient-start), var(--bg-pro-gradient-end));
  background: radial-gradient(
    115.04% 128.1% at 96.27% -10.78%,
    var(--bg-pro-gradient-start) 0%,
    var(--bg-pro-gradient-end) 100%
  );

  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 280px;
  overflow: hidden;

  ${mediaQueries.tablet} {
    max-height: none;
    max-width: 500px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 0 36px 0;
    gap: var(--space-400);

    ${mediaQueries.tablet} {
      padding: 0;
      gap: var(--space-600);
    }
  }

  .swiper-pagination {
    width: fit-content !important;
    left: auto !important;
    right: 12px !important;
    bottom: 12px !important;

    ${mediaQueries.tablet} {
      right: 16px !important;
      bottom: 16px !important;
    }
  }

  .swiper-pagination-bullet {
    width: 6px !important;
    height: 6px !important;
    transition: opacity 0.3s ease-in-out;
    background: var(--color-gray-200) !important;

    ${mediaQueries.tablet} {
      width: 8px !important;
      height: 8px !important;
    }
  }
`;
export const SlideImage = styled.img `
  max-height: 65%;

  ${mediaQueries.tablet} {
    padding: 0 24px;
    width: 356px;
    max-width: 100%;
  }
`;
export const SlideTitle = styled.div `
  margin: 0 20px;
  text-align: center;
  color: var(--text-on-brand);
  font-size: var(--font-size-100);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-100);
  letter-spacing: var(--font-letter-spacing-loosest);

  ${mediaQueries.tablet} {
    font-size: var(--font-size-300);
    line-height: var(--font-line-height-300);
  }
`;
